import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString } from "vue"

const _hoisted_1 = {
  class: "flex items-center gap-1.5",
  "data-testid": "affiliate-competence"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("span", { class: "text-[11px] font-semibold uppercase tracking-wider text-neutral50" }, "Competência", -1)
const _hoisted_3 = ["value"]
const _hoisted_4 = ["value"]

import type { CompetenceOption } from '../competence'


export default /*#__PURE__*/_defineComponent({
  __name: 'AffiliateCompetenceSelect',
  props: {
    modelValue: {},
    options: {}
  },
  emits: ["update:modelValue"],
  setup(__props: any, { emit }) {

const props = __props;




function onChange(event: Event): void {
  const value = (event.target as HTMLSelectElement).value
  if (value && value !== props.modelValue) emit('update:modelValue', value)
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("label", _hoisted_1, [
    _hoisted_2,
    _createElementVNode("select", {
      class: "max-w-[300px] rounded-full border border-[#a3a3a3] bg-white px-3 py-1.5 text-[13px] text-[#525252]",
      "aria-label": "Competência",
      "data-testid": "affiliate-competence-select",
      value: _ctx.modelValue,
      onChange: onChange
    }, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.options, (option) => {
        return (_openBlock(), _createElementBlock("option", {
          key: option.value,
          value: option.value
        }, _toDisplayString(option.label), 9, _hoisted_4))
      }), 128))
    ], 40, _hoisted_3)
  ]))
}
}

})